import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    article_sale_prices_container: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        width: '100%',
        height: 'calc(100vh - 332px)',
        overflow: 'auto'
    },
    article_sale_prices_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    elements_container: {},
    article_sale_prices_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    inactive: {
        borderLeft: `8px solid ${theme.palette.grey["300"]}`,
        backgroundColor: `${theme.palette.grey["300"]}8c`,
        opacity: '0.8'
    },
    menu_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    menu_container_small: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        "& > *": {
            marginLeft: '4px'
        }
    },
    filter_container: {
        display: "grid",
        marginTop: '16px',
        gridTemplateColumns: "repeat( auto-fit, minmax(280px, 1fr) )",
        rowGap: 16,
        marginBottom: '15px',
        "& button": {
            justifySelf: "end"
        }
    },
    tools_container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    search_btn: {
        justifySelf: 'flex-end'
    },
    sale_prices_values_container: {
        display: 'flex',
        gap: '16px',
    },
    currencies_values_container: {
        gap: '50px',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        paddingRight: '16px'
    },
    price_and_button_container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    article_name_container: {
        display: 'flex',
        alignItems: 'center',
    },
    padding_left_10: {
        paddingLeft: '10px'
    },
    article_container: {
        marginBottom: '32px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '8px',
        backgroundColor: theme.palette.grey[50],
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    },
    article_header: {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        paddingBottom: '8px',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    article_name: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    expando_sale_price_button: {
        marginTop: '-16px'
    },
}));

export {useStyles}